const accordions = document.querySelectorAll('.hoox-accordion');

if (accordions && accordions.length) {
    accordions.forEach(accordion => {
        const accordionBtn = accordion.querySelector('.hoox-accordion__header');
        accordionBtn.addEventListener('click', () => {
            toggleAccordion(accordion);
        })
    })

    const accordionsShow = document.querySelectorAll('.hoox-accordion.show-text');
    if (!!accordionsShow.length) {
        accordionsShow.forEach(function (acc) {
            const panel = acc.querySelector('.hoox-accordion__panel');
            panel.style.maxHeight = customHeight(panel) + 'px';
        })
    }
}

function toggleAccordion(accordion) {
    const panel = accordion.querySelector('.hoox-accordion__panel');
    accordion.classList.toggle('show-text');

    panel.style.maxHeight = panel.scrollHeight + 'px';
    !accordion.classList.contains('show-text')
        ? panel.style.maxHeight = null
        : panel.style.maxHeight = customHeight(panel) + 'px';
}

function customHeight(panel) {
    var height = panel.scrollHeight;

    if (panel?.classList.contains('custom-height')) {
        var _height = window.innerWidth < 1024 ? 360 : 210;
        if (height < _height) {
        	panel.closest('.hoox-accordion').classList.add('no-shadow')
        }
        height = _height;
    }

    return height
}
